"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAPPING_PRODOTTO_AMBITO = exports.IconMappingAmbitiPUColor = exports.COMPONENT_TYPE = exports.RESTYLING_PU_ICONS = exports.AMBITI_DI_BISOGNO = exports.IconMappingAmbitiPU = void 0;
exports.IconMappingAmbitiPU = {
    negative: {
        "Casa e Famiglia": "/NextAssets/icons/restyling_pu/w_casa_famiglia.svg",
        Persona: "/NextAssets/icons/restyling_pu/w_persona.svg",
        "Veicoli e Mobilita": "/NextAssets/icons/restyling_pu/w_veicoli_mobilita.svg",
        Casa: "/NextAssets/icons/restyling_pu/w_casa.svg",
        Mobilita: "/NextAssets/icons/restyling_pu/w_mobilita.svg",
        Autocarro: "/NextAssets/icons/restyling_pu/w_autocarro.svg",
        "Cane e Gatto": "/NextAssets/icons/restyling_pu/w_cane_gatto.svg",
        Famiglia: "/NextAssets/icons/restyling_pu/w_famiglia.svg",
        Infortuni: "/NextAssets/icons/restyling_pu/w_infortuni.svg",
        Malattia: "/NextAssets/icons/restyling_pu/w_malattia.svg",
        Salute: "/NextAssets/icons/restyling_pu/w_malattia.svg",
        Moto: "/NextAssets/icons/restyling_pu/w_moto.svg",
        Veicoli: "/NextAssets/icons/restyling_pu/w_veicoli.svg",
        Auto: "/NextAssets/icons/restyling_pu/w_auto.svg",
        Viaggio: "/NextAssets/icons/restyling_pu/w_viaggio.svg",
        "Risparmio e Previdenza": "/NextAssets/icons/restyling_pu/w_risparmio_previdenza.svg",
        Previdenza: "/NextAssets/icons/restyling_pu/w_previdenza.svg",
        Unica: "/NextAssets/icons/restyling_pu/w_unica.svg",
        "Angle Right": "/NextAssets/icons/restyling_pu/w_angle_right.svg",
        Users: "/NextAssets/icons/restyling_pu/w_users.svg",
        Close: "/NextAssets/icons/restyling_pu/w_close.svg",
    },
    positive: {
        "Casa e Famiglia": "/NextAssets/icons/restyling_pu/b_casa_famiglia.svg",
        Persona: "/NextAssets/icons/restyling_pu/b_persona.svg",
        "Veicoli e Mobilita": "/NextAssets/icons/restyling_pu/b_veicoli_mobilita.svg",
        Casa: "/NextAssets/icons/restyling_pu/b_casa.svg",
        Mobilita: "/NextAssets/icons/restyling_pu/b_mobilita.svg",
        Autocarro: "/NextAssets/icons/restyling_pu/b_autocarro.svg",
        "Cane e Gatto": "/NextAssets/icons/restyling_pu/b_cane_gatto.svg",
        Famiglia: "/NextAssets/icons/restyling_pu/b_famiglia.svg",
        Infortuni: "/NextAssets/icons/restyling_pu/b_infortuni.svg",
        Malattia: "/NextAssets/icons/restyling_pu/b_malattia.svg",
        Salute: "/NextAssets/icons/restyling_pu/b_malattia.svg",
        Moto: "/NextAssets/icons/restyling_pu/b_moto.svg",
        Veicoli: "/NextAssets/icons/restyling_pu/b_veicoli.svg",
        Auto: "/NextAssets/icons/restyling_pu/b_auto.svg",
        Viaggio: "/NextAssets/icons/restyling_pu/b_viaggio.svg",
        "Risparmio e Previdenza": "/NextAssets/icons/restyling_pu/b_previdenza.svg",
        Previdenza: "/NextAssets/icons/restyling_pu/b_previdenza.svg",
        Unica: "/NextAssets/icons/restyling_pu/b_unica.svg",
        ServizioClienti: "/NextAssets/icons/restyling_pu/b_servizio_clienti.svg",
        Users: "/NextAssets/icons/restyling_pu/b_users.svg",
        TrovaAgenzia: "/NextAssets/icons/restyling_pu/b_trova_agenzia.svg",
        Carrello: "/NextAssets/icons/restyling_pu/b_carrello.svg",
        Search: "/NextAssets/icons/restyling_pu/b_search.svg",
        Esci: "/NextAssets/icons/restyling_pu/b_esci.svg",
    },
    ambito: {
        "Casa e Famiglia": "/NextAssets/icons/restyling_pu/a_casa_famiglia.svg",
        Persona: "/NextAssets/icons/restyling_pu/a_persona.svg",
        "Veicoli e Mobilita": "/NextAssets/icons/restyling_pu/a_veicoli_mobilita.svg",
        Casa: "/NextAssets/icons/restyling_pu/a_casa.svg",
        Mobilita: "/NextAssets/icons/restyling_pu/a_mobilita.svg",
        Autocarro: "/NextAssets/icons/restyling_pu/a_autocarro.svg",
        "Cane e Gatto": "/NextAssets/icons/restyling_pu/a_cane_gatto.svg",
        Famiglia: "/NextAssets/icons/restyling_pu/a_famiglia.svg",
        Infortuni: "/NextAssets/icons/restyling_pu/a_infortuni.svg",
        Malattia: "/NextAssets/icons/restyling_pu/a_malattia.svg",
        Salute: "/NextAssets/icons/restyling_pu/a_malattia.svg",
        Moto: "/NextAssets/icons/restyling_pu/a_moto.svg",
        Veicoli: "/NextAssets/icons/restyling_pu/a_veicoli.svg",
        Auto: "/NextAssets/icons/restyling_pu/a_auto.svg",
        Viaggio: "/NextAssets/icons/restyling_pu/a_viaggio.svg",
        "Risparmio e Previdenza": "/NextAssets/icons/restyling_pu/a_risparmio.svg",
        Unica: "/NextAssets/icons/restyling_pu/a_unica.svg",
    },
    bicolor: {
        "Casa e Famiglia": "/NextAssets/icons/restyling_pu/bicolor_casa_famiglia.svg",
        Persona: "/NextAssets/icons/restyling_pu/bicolor_persona.svg",
        "Veicoli e Mobilita": "/NextAssets/icons/restyling_pu/bicolor_veicoli_mobilita.svg",
        Casa: "/NextAssets/icons/restyling_pu/bicolor_casa.svg",
        Mobilita: "/NextAssets/icons/restyling_pu/bicolor_mobilita.svg",
        Autocarro: "/NextAssets/icons/restyling_pu/bicolor_autocarro.svg",
        "Cane e Gatto": "/NextAssets/icons/restyling_pu/bicolor_cane_gatto.svg",
        Famiglia: "/NextAssets/icons/restyling_pu/bicolor_famiglia.svg",
        Infortuni: "/NextAssets/icons/restyling_pu/bicolor_infortuni.svg",
        Malattia: "/NextAssets/icons/restyling_pu/bicolor_malattia.svg",
        Salute: "/NextAssets/icons/restyling_pu/bicolor_malattia.svg",
        Moto: "/NextAssets/icons/restyling_pu/bicolor_moto.svg",
        Veicoli: "/NextAssets/icons/restyling_pu/bicolor_veicoli.svg",
        Auto: "/NextAssets/icons/restyling_pu/bicolor_auto.svg",
        Viaggio: "/NextAssets/icons/restyling_pu/bicolor_viaggio.svg",
        "Risparmio e Previdenza": "/NextAssets/icons/restyling_pu/bicolor_previdenza.svg",
        Previdenza: "/NextAssets/icons/restyling_pu/bicolor_previdenza.svg",
        Unica: "/NextAssets/icons/restyling_pu/bicolor_unica.svg",
    },
};
exports.AMBITI_DI_BISOGNO = {
    "Casa e Famiglia": {
        MAIN_COLOR: "rgba(233, 77, 16, 1)",
        BG_HEADER: "#E94D10",
        BG_DISCOUNT: "#FDF5F2",
        BG_BODY: "#FDF5F2",
    },
    "Risparmio e Previdenza": {
        MAIN_COLOR: "rgba(83, 147, 188, 1)",
        BG_HEADER: "#5393BC",
        BG_DISCOUNT: "#E8F5FF",
        BG_BODY: "#E8F5FF",
    },
    Persona: {
        MAIN_COLOR: "rgba(89, 166, 39, 1)",
        BG_HEADER: "#59A627",
        BG_DISCOUNT: "#F5FAED",
        BG_BODY: "#F5FAED",
    },
    "Veicoli e Mobilita": {
        MAIN_COLOR: "rgba(1, 105, 180, 1)",
        BG_HEADER: "#0169B4",
        BG_DISCOUNT: "#E8F5FF",
        BG_BODY: "#E8F5FF",
    },
};
exports.RESTYLING_PU_ICONS = {
    ANGLE_RIGHT: "/NextAssets/icons/angle-right.svg",
    SPUNTA: "/NextAssets/icons/spunta.svg",
    CERCHIO: "",
    QUADRATO: "",
    NESSUNA_ICONA: "",
};
var COMPONENT_TYPE;
(function (COMPONENT_TYPE) {
    COMPONENT_TYPE["H1"] = "h1";
    COMPONENT_TYPE["H2"] = "h2";
    COMPONENT_TYPE["H3"] = "h3";
})(COMPONENT_TYPE = exports.COMPONENT_TYPE || (exports.COMPONENT_TYPE = {}));
exports.IconMappingAmbitiPUColor = {
    "Casa e Famiglia": exports.AMBITI_DI_BISOGNO["Casa e Famiglia"].MAIN_COLOR,
    Persona: exports.AMBITI_DI_BISOGNO["Persona"].MAIN_COLOR,
    "Veicoli e Mobilita": exports.AMBITI_DI_BISOGNO["Veicoli e Mobilita"].MAIN_COLOR,
    Casa: exports.AMBITI_DI_BISOGNO["Casa e Famiglia"].MAIN_COLOR,
    Mobilita: exports.AMBITI_DI_BISOGNO["Veicoli e Mobilita"].MAIN_COLOR,
    Autocarro: exports.AMBITI_DI_BISOGNO["Veicoli e Mobilita"].MAIN_COLOR,
    "Cane e Gatto": exports.AMBITI_DI_BISOGNO["Casa e Famiglia"].MAIN_COLOR,
    Famiglia: exports.AMBITI_DI_BISOGNO["Casa e Famiglia"].MAIN_COLOR,
    Infortuni: exports.AMBITI_DI_BISOGNO["Persona"].MAIN_COLOR,
    Malattia: exports.AMBITI_DI_BISOGNO["Persona"].MAIN_COLOR,
    Salute: exports.AMBITI_DI_BISOGNO["Persona"].MAIN_COLOR,
    Moto: exports.AMBITI_DI_BISOGNO["Veicoli e Mobilita"].MAIN_COLOR,
    Veicoli: exports.AMBITI_DI_BISOGNO["Veicoli e Mobilita"].MAIN_COLOR,
    Viaggio: exports.AMBITI_DI_BISOGNO["Casa e Famiglia"].MAIN_COLOR,
    "Risparmio e Previdenza": exports.AMBITI_DI_BISOGNO["Risparmio e Previdenza"].MAIN_COLOR,
    Previdenza: exports.AMBITI_DI_BISOGNO["Risparmio e Previdenza"].MAIN_COLOR,
};
exports.MAPPING_PRODOTTO_AMBITO = {
    Auto: "Veicoli",
    Moto: "Veicoli",
    Autocarri: "Veicoli",
    Mobilità: "Mobilità",
    Viaggio: "Famiglia",
    Casa: "Casa",
    Famiglia: "Famiglia",
    "Cane/Gatto": "Famiglia",
    Infortuni: "Persona",
    Salute: "Persona"
};
